var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterPlataforma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 217,
    height: 53,
    viewBox: "0 0 217 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-footerPlataforma"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217,
    height: 53
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "footerPlataforma",
    clipPath: "url(#clip-footerPlataforma)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1000",
    "data-name": "Grupo 1000",
    transform: "translate(-166.883 -594.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_238",
    "data-name": "Trazado 238",
    d: "M1110.574,852.465a2.826,2.826,0,0,1-.932,2.283,3.989,3.989,0,0,1-2.652.79h-.841v3.288h-1.96v-9.244h2.953a3.929,3.929,0,0,1,2.558.724,2.64,2.64,0,0,1,.876,2.159m-4.426,1.467h.645a2.148,2.148,0,0,0,1.353-.357,1.25,1.25,0,0,0,.449-1.04,1.282,1.282,0,0,0-.376-1.018,1.764,1.764,0,0,0-1.179-.329h-.891Z",
    transform: "translate(-879.971 -238.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_239",
    "data-name": "Trazado 239",
    d: "M1222.98,858.826v-9.244h1.96v7.626h3.75v1.619Z",
    transform: "translate(-991.616 -238.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_240",
    "data-name": "Trazado 240",
    d: "M1315.7,858.233l-.67-2.2h-3.37l-.67,2.2h-2.112l3.263-9.282h2.4l3.275,9.282Zm-1.138-3.844q-.93-2.991-1.047-3.383t-.168-.62q-.209.809-1.2,4Z",
    transform: "translate(-1072.346 -238.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_241",
    "data-name": "Trazado 241",
    d: "M1449.8,858.826h-1.96v-7.613h-2.51v-1.631h6.981v1.631h-2.51Z",
    transform: "translate(-1200.584 -238.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_242",
    "data-name": "Trazado 242",
    d: "M1556.123,858.233l-.67-2.2h-3.37l-.67,2.2H1549.3l3.263-9.282h2.4l3.275,9.282Zm-1.138-3.844q-.93-2.991-1.047-3.383t-.168-.62q-.209.809-1.195,4Z",
    transform: "translate(-1298.302 -238.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_243",
    "data-name": "Trazado 243",
    d: "M1702.7,858.826h-1.929v-9.244h5.3v1.606h-3.37v2.384h3.136v1.6H1702.7Z",
    transform: "translate(-1440.664 -238.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_244",
    "data-name": "Trazado 244",
    d: "M1804.514,851.919a5.016,5.016,0,0,1-1.138,3.528,4.933,4.933,0,0,1-6.525,0,5.036,5.036,0,0,1-1.138-3.541,4.967,4.967,0,0,1,1.141-3.525,4.268,4.268,0,0,1,3.272-1.217,4.209,4.209,0,0,1,3.259,1.227,5.029,5.029,0,0,1,1.129,3.528m-6.747,0a3.861,3.861,0,0,0,.588,2.333,2.058,2.058,0,0,0,1.758.784q2.346,0,2.346-3.117t-2.333-3.124a2.072,2.072,0,0,0-1.764.787,3.845,3.845,0,0,0-.594,2.336",
    transform: "translate(-1529.889 -236.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_245",
    "data-name": "Trazado 245",
    d: "M1959.448,855.278v3.547h-1.96v-9.244h2.694a4.611,4.611,0,0,1,2.788.686,2.735,2.735,0,0,1,.455,3.535,2.968,2.968,0,0,1-1.271,1q2.087,3.117,2.719,4.028H1962.7l-2.207-3.547Zm0-1.593h.632a2.419,2.419,0,0,0,1.372-.31,1.106,1.106,0,0,0,.443-.974,1.012,1.012,0,0,0-.452-.936,2.744,2.744,0,0,0-1.4-.278h-.594Z",
    transform: "translate(-1681.931 -238.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_246",
    "data-name": "Trazado 246",
    d: "M2087.13,858.826l-2.226-7.253h-.056q.12,2.213.119,2.953v4.3h-1.751v-9.244h2.669l2.188,7.069h.038l2.321-7.069h2.668v9.244h-1.827v-4.376c0-.206,0-.445.009-.714s.035-.987.086-2.15h-.057l-2.384,7.24Z",
    transform: "translate(-1800.095 -238.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_247",
    "data-name": "Trazado 247",
    d: "M2257.28,858.233l-.67-2.2h-3.37l-.67,2.2h-2.112l3.262-9.282h2.4l3.275,9.282Zm-1.138-3.844q-.929-2.991-1.046-3.383t-.168-.62q-.209.809-1.2,4Z",
    transform: "translate(-1957.274 -238.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1393",
    "data-name": "Rect\\xE1ngulo 1393",
    width: 2.412,
    height: 11.378,
    transform: "translate(224.485 623.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_248",
    "data-name": "Trazado 248",
    d: "M1195.831,1077.722h-3.066l-4.95-8.607h-.07q.148,2.28.148,3.253v5.354h-2.156v-11.377h3.043l4.942,8.521h.055q-.117-2.218-.117-3.136v-5.385h2.171Z",
    transform: "translate(-956.615 -442.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_249",
    "data-name": "Trazado 249",
    d: "M1399.942,1071.925a5.6,5.6,0,0,1-1.6,4.3,6.522,6.522,0,0,1-4.619,1.494H1390.5v-11.377h3.572a6.015,6.015,0,0,1,4.327,1.471,5.411,5.411,0,0,1,1.541,4.109m-2.506.062q0-3.666-3.237-3.665h-1.284v7.409h1.035q3.486,0,3.486-3.743",
    transform: "translate(-1149.058 -442.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_250",
    "data-name": "Trazado 250",
    d: "M1584.04,1066.345v7.362a4.245,4.245,0,0,1-.564,2.21,3.674,3.674,0,0,1-1.631,1.455,5.828,5.828,0,0,1-2.521.506,4.827,4.827,0,0,1-3.409-1.125,3.989,3.989,0,0,1-1.214-3.078v-7.331h2.4v6.965a2.916,2.916,0,0,0,.529,1.93,2.2,2.2,0,0,0,1.751.615,2.152,2.152,0,0,0,1.716-.619,2.935,2.935,0,0,0,.533-1.942v-6.95Z",
    transform: "translate(-1322.176 -442.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_251",
    "data-name": "Trazado 251",
    d: "M1761.4,1072.01a2.941,2.941,0,0,1-1.109,2.428,4.816,4.816,0,0,1-3.085.887,7.246,7.246,0,0,1-3.222-.685V1072.4a13.247,13.247,0,0,0,1.949.724,5.77,5.77,0,0,0,1.459.21,2.075,2.075,0,0,0,1.218-.3,1.037,1.037,0,0,0,.424-.9,1,1,0,0,0-.187-.6,2.092,2.092,0,0,0-.549-.5,14.115,14.115,0,0,0-1.474-.771,6.981,6.981,0,0,1-1.565-.942,3.531,3.531,0,0,1-.833-1.051,3,3,0,0,1-.311-1.4,2.939,2.939,0,0,1,1.023-2.374,4.251,4.251,0,0,1,2.829-.864,6.677,6.677,0,0,1,1.693.21,11.628,11.628,0,0,1,1.685.592l-.778,1.875a11.4,11.4,0,0,0-1.506-.521,4.85,4.85,0,0,0-1.171-.148,1.55,1.55,0,0,0-1.051.319,1.052,1.052,0,0,0-.366.833,1.027,1.027,0,0,0,.148.556,1.62,1.62,0,0,0,.47.459,14.638,14.638,0,0,0,1.529.8,6.084,6.084,0,0,1,2.187,1.529,2.985,2.985,0,0,1,.592,1.879",
    transform: "translate(-1490.672 -440.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_252",
    "data-name": "Trazado 252",
    d: "M1887.938,1077.722h-2.412v-9.37h-3.089v-2.008h8.591v2.008h-3.089Z",
    transform: "translate(-1611.395 -442.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_253",
    "data-name": "Trazado 253",
    d: "M2046.151,1073.357v4.366h-2.412v-11.377h3.315a5.673,5.673,0,0,1,3.432.844,3.367,3.367,0,0,1,.56,4.35,3.655,3.655,0,0,1-1.564,1.226q2.568,3.836,3.346,4.957h-2.677l-2.716-4.366Zm0-1.961h.778a2.977,2.977,0,0,0,1.689-.381,1.361,1.361,0,0,0,.545-1.2,1.245,1.245,0,0,0-.556-1.152,3.375,3.375,0,0,0-1.724-.342h-.732Z",
    transform: "translate(-1762.993 -442.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1394",
    "data-name": "Rect\\xE1ngulo 1394",
    width: 2.412,
    height: 11.378,
    transform: "translate(290.63 623.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_254",
    "data-name": "Trazado 254",
    d: "M2269.715,1076.992l-.825-2.708h-4.148l-.825,2.708h-2.6l4.016-11.424h2.949l4.031,11.424Zm-1.4-4.731q-1.144-3.681-1.288-4.164t-.206-.762q-.257,1-1.471,4.926Z",
    transform: "translate(-1967.481 -441.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_255",
    "data-name": "Trazado 255",
    d: "M2512.435,1065.636a2.457,2.457,0,0,0-2.109,1.023,4.76,4.76,0,0,0-.748,2.852q0,3.805,2.856,3.806a9.027,9.027,0,0,0,2.9-.6v2.023a8.059,8.059,0,0,1-3.129.584,4.771,4.771,0,0,1-3.8-1.506,6.376,6.376,0,0,1-1.315-4.323,7.062,7.062,0,0,1,.646-3.109,4.67,4.67,0,0,1,1.856-2.047,5.49,5.49,0,0,1,2.837-.712,7.654,7.654,0,0,1,3.331.8l-.778,1.961a12.909,12.909,0,0,0-1.285-.529,3.824,3.824,0,0,0-1.268-.225",
    transform: "translate(-2198.472 -440.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1395",
    "data-name": "Rect\\xE1ngulo 1395",
    width: 2.412,
    height: 11.378,
    transform: "translate(318.648 623.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_256",
    "data-name": "Trazado 256",
    d: "M2753.217,1073.357v4.366H2750.8v-11.377h3.315a5.674,5.674,0,0,1,3.432.844,3.366,3.366,0,0,1,.561,4.35,3.655,3.655,0,0,1-1.565,1.226q2.569,3.836,3.346,4.957h-2.677l-2.716-4.366Zm0-1.961H2754a2.975,2.975,0,0,0,1.688-.381,1.361,1.361,0,0,0,.545-1.2,1.245,1.245,0,0,0-.556-1.152,3.375,3.375,0,0,0-1.724-.342h-.732Z",
    transform: "translate(-2427.517 -442.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_257",
    "data-name": "Trazado 257",
    d: "M2912.015,1065.636a2.458,2.458,0,0,0-2.109,1.023,4.76,4.76,0,0,0-.747,2.852q0,3.805,2.856,3.806a9.019,9.019,0,0,0,2.9-.6v2.023a8.053,8.053,0,0,1-3.128.584,4.77,4.77,0,0,1-3.8-1.506,6.373,6.373,0,0,1-1.316-4.323,7.059,7.059,0,0,1,.646-3.109,4.668,4.668,0,0,1,1.856-2.047,5.492,5.492,0,0,1,2.837-.712,7.654,7.654,0,0,1,3.331.8l-.779,1.961a12.914,12.914,0,0,0-1.284-.529,3.83,3.83,0,0,0-1.268-.225",
    transform: "translate(-2574.01 -440.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_258",
    "data-name": "Trazado 258",
    d: "M3081.327,1066.345v7.362a4.241,4.241,0,0,1-.565,2.21,3.667,3.667,0,0,1-1.63,1.455,5.829,5.829,0,0,1-2.521.506,4.826,4.826,0,0,1-3.408-1.125,3.989,3.989,0,0,1-1.214-3.078v-7.331h2.4v6.965a2.917,2.917,0,0,0,.529,1.93,2.2,2.2,0,0,0,1.751.615,2.15,2.15,0,0,0,1.716-.619,2.934,2.934,0,0,0,.534-1.942v-6.95Z",
    transform: "translate(-2729.377 -442.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_259",
    "data-name": "Trazado 259",
    d: "M3262.914,1077.722v-11.377h2.413v9.385h4.615v1.992Z",
    transform: "translate(-2908.815 -442.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_260",
    "data-name": "Trazado 260",
    d: "M3386.567,1076.992l-.825-2.708h-4.147l-.825,2.708h-2.6l4.016-11.424h2.949l4.031,11.424Zm-1.4-4.731q-1.144-3.681-1.288-4.164t-.206-.762q-.256,1-1.471,4.926Z",
    transform: "translate(-3017.136 -441.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_261",
    "data-name": "Trazado 261",
    d: "M3576.552,1073.357v4.366h-2.412v-11.377h3.315a5.674,5.674,0,0,1,3.432.844,3.367,3.367,0,0,1,.56,4.35,3.656,3.656,0,0,1-1.564,1.226q2.568,3.836,3.346,4.957h-2.678l-2.716-4.366Zm0-1.961h.778a2.978,2.978,0,0,0,1.689-.381,1.361,1.361,0,0,0,.545-1.2,1.245,1.245,0,0,0-.557-1.152,3.376,3.376,0,0,0-1.724-.342h-.731Z",
    transform: "translate(-3201.315 -442.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_262",
    "data-name": "Trazado 262",
    d: "M167.883,621.207a30.325,30.325,0,0,1,.748-6.842,26.4,26.4,0,0,1,18.6-18.174c1.23-.322,13.21-3.238,23.2,5.025a25.9,25.9,0,0,1,9.087,23.626c-1.48,8.961-8.337,15.286-8.66,15.288-.481,0,1.222-1.976,2.459-5.238a29.355,29.355,0,0,0,1.575-12.771,22.548,22.548,0,0,0-14.831-18.339,23.911,23.911,0,0,0-16.143-.107,22.881,22.881,0,0,0-10.691,8.018,58.286,58.286,0,0,0-5.345,9.515",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_263",
    "data-name": "Trazado 263",
    d: "M354.949,743.687c-.035.17,1.711.517,3.742,1.283a19.14,19.14,0,0,1,8.751,7.671,16.658,16.658,0,0,1,2.474,8.686,17.6,17.6,0,0,1-1.495,9.211,18.082,18.082,0,0,1-5.962,7.4c-5.586,4.436-12.731,4.009-14.7,3.6-5.155-1.068-7.334-3.762-7.557-3.379s2.612,2.893,6.113,4.643a20.3,20.3,0,0,0,13.756,1.344,20.594,20.594,0,0,0,15.569-19.128,20,20,0,0,0-4.123-13.2,19.642,19.642,0,0,0-10.8-7.377c-2.743-.718-5.728-.965-5.773-.748",
    transform: "translate(-161.943 -139.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_264",
    "data-name": "Trazado 264",
    d: "M239.293,851.384c.222.128-1.368,2.148-2.031,4.383-.31,1.045-1.176,3.368-.535,8.339a15.134,15.134,0,0,0,4.7,8.766c.654.617,5.57,5.308,12.722,4.49a17.832,17.832,0,0,0,11.225-6.2c2.321-2.666,2.606-6.28,2.931-6.174.293.1-.144,2.526-.958,4.916a16.953,16.953,0,0,1-4.832,7.229,16.585,16.585,0,0,1-8.256,4.082,18.83,18.83,0,0,1-6.533,0,16.415,16.415,0,0,1-7.226-3.236,17.065,17.065,0,0,1-6.477-16.825,20.377,20.377,0,0,1,1.951-5.813c1.021-1.943,3.072-4.095,3.314-3.956",
    transform: "translate(-61.895 -240.547)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPlataforma);
export default __webpack_public_path__ + "static/media/footerPlataforma.115a24b606b6c2517750926d6c088b47.svg";
export { ForwardRef as ReactComponent };